import { useState } from "react";
import { ButtonSpinner } from "../../components/CommonMethod";
import { fetchData, SEND_TEST_MAIL } from "../../components/Service";


function SendTestMail() {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);

    const sendMail = () => {
        setLoading(true)
        fetchData(SEND_TEST_MAIL, 'POST', { email }, true, false, (res) => {
            setLoading(false)
            if (res.success) setEmail('');
        })
    }

    return (
        <div className='row mt-5'>
            <h1 className="h3 text-dim mb-0">Send Test Mail</h1>
            <div class="input-group has-validation mt-3">
                <span class="input-group-text">@</span>
                <div class="form-floating">
                    <input value={email} onChange={(e) => setEmail(e.target.value)} type="text" class="form-control" id="floatingInputGroup2" placeholder="Username" required />
                    <label htmlFor="floatingInputGroup2">Username</label>
                </div>
                <button type="button" disabled={loading} className="input-group-text" onClick={sendMail}>
                    <ButtonSpinner load={loading} btnName="Send Mail" />
                </button>
            </div>
        </div>
    )
}
export default SendTestMail
